import magnifiAPIInstance from "./apiInstance";

export const appSettingsAPIs = {
  getCreatedSports: ({ payload }) => magnifiAPIInstance.post(`/get_created_sports`, payload),
};
